import { render, staticRenderFns } from "./TransactionDetail.vue?vue&type=template&id=4b2a6242&scoped=true"
import script from "./TransactionDetail.vue?vue&type=script&lang=js"
export * from "./TransactionDetail.vue?vue&type=script&lang=js"
import style0 from "./TransactionDetail.vue?vue&type=style&index=0&id=4b2a6242&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2a6242",
  null
  
)

export default component.exports